import {
  CheckCircle2,
  AlertTriangle,
  MinusCircle,
  XCircle,
} from "lucide-react";

export const PAGE_TYPE_COLORS: Record<string, string> = {
  single_line_diagram: "bg-blue-500",
  panel_schedule: "bg-indigo-500",
  boq: "bg-emerald-500",
  layout_plan: "bg-amber-500",
  cover: "bg-gray-400",
  general_notes: "bg-teal-500",
  cable_schedule: "bg-purple-500",
  detail_drawing: "bg-orange-500",
  table_of_contents: "bg-gray-300",
  title_page: "bg-gray-300",
};

export const SEVERITY_STYLES: Record<string, string> = {
  critical: "bg-red-50 border-red-200 text-red-800",
  warning: "bg-amber-50 border-amber-200 text-amber-800",
  info: "bg-blue-50 border-blue-200 text-blue-800",
};

export const SEVERITY_BADGE: Record<string, string> = {
  critical: "bg-red-100 text-red-700",
  warning: "bg-amber-100 text-amber-700",
  info: "bg-blue-100 text-blue-700",
};

export const IMPORTANCE_BORDER: Record<string, string> = {
  high: "border-l-red-500",
  medium: "border-l-amber-400",
  low: "border-l-gray-300",
};

export const IMPORTANCE_BADGE: Record<string, string> = {
  high: "bg-red-100 text-red-700",
  medium: "bg-amber-100 text-amber-700",
  low: "bg-gray-100 text-gray-600",
};

export const RECON_STATUS_STYLES: Record<
  string,
  { bg: string; text: string; icon: typeof CheckCircle2 }
> = {
  matched: { bg: "bg-green-50", text: "text-green-700", icon: CheckCircle2 },
  quantity_mismatch: {
    bg: "bg-amber-50",
    text: "text-amber-700",
    icon: AlertTriangle,
  },
  takeoff_only: {
    bg: "bg-blue-50",
    text: "text-blue-700",
    icon: MinusCircle,
  },
  client_only: { bg: "bg-red-50", text: "text-red-700", icon: XCircle },
};
